/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PathologyStrictHttpResponse } from '../../pathology-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PdfSubmissionModel } from '../../models/pdf-submission-model';

export interface PathologyIdSubmitPost$Params {
  id: string;
      body?: PdfSubmissionModel
}

export function pathologyIdSubmitPost(http: HttpClient, rootUrl: string, params: PathologyIdSubmitPost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, pathologyIdSubmitPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as PathologyStrictHttpResponse<void>;
    })
  );
}

pathologyIdSubmitPost.PATH = '/Pathology/{id}/Submit';
